import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38766d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-item-label"
}
const _hoisted_2 = { class: "first-row" }
const _hoisted_3 = { class: "product-name-priceLine" }
const _hoisted_4 = { class: "product-exchange-delete" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path1 fs-44" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path2 fs-44" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path3 fs-44" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-f path4 fs-44" }, null, -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "second-row" }
const _hoisted_11 = { class: "item-quantity" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "product-item-title-style" }
const _hoisted_17 = {
  key: 1,
  class: "product-item-value-style"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1))
const _hoisted_22 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "item-unit-price" }
const _hoisted_24 = { class: "product-item-title-style" }
const _hoisted_25 = {
  key: 1,
  class: "product-item-value-style"
}
const _hoisted_26 = { class: "item-discount" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "product-item-title-style" }
const _hoisted_32 = {
  key: 1,
  class: "product-item-value-style"
}
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path1" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path2" }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "path3" }, null, -1))
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "product-item-total" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1))
const _hoisted_40 = {
  key: 1,
  class: "warning-item"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-item", {
      'product-item-active': _ctx.active,
      warning: _ctx.isWarning || _ctx.product.notValidCoupon,
      notValidCoupon: _ctx.product.notValidCoupon,
      'with-coupon': _ctx.couponExist,
    }])
  }, [
    (_ctx.couponExist)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("cashier.label.coupon")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.product.name) + " - " + _toDisplayString(_ctx.product.priceLine?.name ? _ctx.product.priceLine.name : "?"), 1),
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeSlotByPriceDuration(_ctx.index))),
        class: "c-pointer product-slot-date"
      }, _toDisplayString(_ctx.getDisplayDate(_ctx.product.date)) + "   " + _toDisplayString(_ctx.getDisplayDateTime(_ctx.product.slotStartTime)) + "-" + _toDisplayString(_ctx.getDisplayDateTime(_ctx.product.slotEndTime)), 1),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isVoucherItem && !_ctx.isImmutable)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "icon-f icon-swap-price mr-28 dir-ltr",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exchange(_ctx.index)))
            }, _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.isImmutable)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "icon-f icon-recycle",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeProduct(_ctx.index)))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("span", {
                class: "icon-f icon-minus d-none-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.minusQuontity(_ctx.index)))
              }, _hoisted_15)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("cashier.label.quantity")), 1),
          (_ctx.active)
            ? (_openBlock(), _createBlock(_component_InputNumber, {
                key: 0,
                readonly: _ctx.product.notValidCoupon || !!_ctx.product.cardCode,
                required: "",
                class: "live-change-input",
                modelValue: _ctx.product.priceLine.quantity,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.product.priceLine.quantity) = $event)),
                min: 0,
                allowEmpty: false,
                onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.quantityFocus($event))),
                onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.quantityBlur($event)))
              }, null, 8, ["readonly", "modelValue"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.product.priceLine.quantity), 1))
        ]),
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("span", {
                class: "icon-f icon-plus d-none-item",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.plusQuontity(_ctx.index)))
              }, _hoisted_22)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("cashier.label.unit-price")), 1),
          (_ctx.active)
            ? (_openBlock(), _createBlock(_component_InputNumber, {
                key: 0,
                readonly: 
              !_ctx.changeUnitPrice || _ctx.product.notValidCoupon || !!_ctx.isImmutable
            ,
                required: "",
                class: "live-change-input",
                modelValue: _ctx.product.priceLine.priceForOne,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.product.priceLine.priceForOne) = $event)),
                min: 0,
                allowEmpty: false,
                suffix: ' ' + _ctx.currencySign,
                onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePriceForOne($event, _ctx.product.defaultPriceForOne)))
              }, null, 8, ["readonly", "modelValue", "suffix"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.product.priceLine.priceForOne) + " " + _toDisplayString(_ctx.currencySign), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_ctx.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              (_ctx.canEditDiscount && !_ctx.isVoucherItem)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "icon-f icon-minus d-none-item",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.minusDiscount(_ctx.index)))
                  }, _hoisted_30))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("cashier.label.discount")), 1),
          (_ctx.active)
            ? (_openBlock(), _createBlock(_component_InputNumber, {
                key: 0,
                disabled: !_ctx.canEditDiscount || _ctx.product.notValidCoupon,
                readonly: !_ctx.canEditDiscount || _ctx.product.notValidCoupon,
                required: "",
                class: "live-change-input",
                modelValue: _ctx.product.priceLine.discount,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.product.priceLine.discount) = $event)),
                allowEmpty: true,
                onFocus: _cache[12] || (_cache[12] = ($event: any) => (
              _ctx.product.priceLine.discount =
                _ctx.product.priceLine.discount == 0
                  ? ''
                  : _ctx.product.priceLine.discount.toString().split(',').join('')
            )),
                onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.checkDiscountByRestriction($event, _ctx.product)))
              }, null, 8, ["disabled", "readonly", "modelValue"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.formatAmount(_ctx.product.priceLine.discount)), 1))
        ]),
        (_ctx.active || _ctx.isWarning || _ctx.product.notValidCoupon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              (_ctx.canEditDiscount && !_ctx.isVoucherItem)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "icon-f icon-plus d-none-item",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.plusDiscount(_ctx.index)))
                  }, _hoisted_37))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("span", null, _toDisplayString(_ctx.formatAmount(
              Math.max(
                0,
                _ctx.product.priceLine.priceForOne * _ctx.product.priceLine.quantity -
                  _ctx.product.priceLine.discount
              )
            )), 1),
        _hoisted_39,
        _createElementVNode("span", null, _toDisplayString(_ctx.currencySign), 1)
      ])
    ]),
    (_ctx.product.notValidCoupon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, "!"))
      : _createCommentVNode("", true)
  ], 2))
}